export const BUTTON_TYPE = {
    button: 'button',
    submit: 'submit',
    reset: 'reset',
} as const

export const BUTTON_THEME = {
    primary: 'primary',
    secondary: 'secondary',
    white: 'white',
    transparent: 'transparent',
} as const

export const BUTTON_MODIFIER = {
    round: 'round',
    circular: 'circular',
    clean: 'clean',
} as const

export const BUTTON_SIZE = {
    none: 'none',
    small: 'small',
    normal: 'normal',
    medium: 'medium',
    big: 'big',
} as const
